import axios from "axios";
import axiosAccount, { ApiClientAccount } from "./axiosAccount";
import { IPostReturn } from "../Backend/post";
import { ICheckoutSession } from "@/services/account/interfaces/ICheckoutSession";
import { IActiveSubscription } from "./interfaces/IActiveSubscription";

export class AccountService {
    static createPaymentLink = async (data: { planId: string }): Promise<IPostReturn<{ url: string }>> => {
        return await ApiClientAccount.post("/stripe/create/payment-link", data);
    };
    static createCustomerPortalSession = async ({
        activeSubscriptionId,
    }: {
        activeSubscriptionId?: string;
    }): Promise<IPostReturn<{ url: string }>> => {
        return await ApiClientAccount.post("/stripe/create/customer-portal-session", {
            activeSubscriptionId: activeSubscriptionId,
        });
    };

    static getCheckoutSession = async (sessionId: string): Promise<IPostReturn<ICheckoutSession>> => {
        return await ApiClientAccount.get(`/stripe/checkout-session/${sessionId}`);
    };

    static getActiveSubscription = async (): Promise<IPostReturn<IActiveSubscription>> => {
        return await ApiClientAccount.get("/subscription/current");
    };
    static getAllSubscription = async (): Promise<IPostReturn<IActiveSubscription[]>> => {
        return await ApiClientAccount.get("/subscription/all");
    };

    static refreshSubscription = async (subscriptionId: string): Promise<IPostReturn<boolean>> => {
        return await ApiClientAccount.post(`/subscription/refresh/${subscriptionId}`, {});
    };
}
